module.exports = __webpack_public_path__ + "img/shipping-fast-regular.f5d379f7.svg";